export default __webpack_public_path__ + "static/bncff-screens-mobile-2223e9b81c22d4297243d27d8e499e7a.jpg";